import React from 'react';
import { Shimmer, ShimmerElementType } from '@fluentui/react';

const headerElement = [
  { type: ShimmerElementType.line, height: 16, width: '10%' },
  { type: ShimmerElementType.gap, width: '40%' },
  { type: ShimmerElementType.line, height: 16, width: '10%' },
  { type: ShimmerElementType.gap, width: '10%' },
  { type: ShimmerElementType.line, height: 16, width: '10%' },
  { type: ShimmerElementType.gap, width: '10%' },
  { type: ShimmerElementType.line, height: 16, width: '10%' },
];
const rowElement = [{ type: ShimmerElementType.line, height: 32 }];
const buttonElement = [
  { type: ShimmerElementType.line, height: 32, width: '25%' },
  { type: ShimmerElementType.gap, width: '60%' },
  { type: ShimmerElementType.line, height: 16, width: '15%' },
];

export function TableShimmer() {
  return (
    <div className="shimmer-container">
      <Shimmer shimmerElements={headerElement} style={{ marginBottom: 8 }} />
      <Shimmer shimmerElements={rowElement} style={{ marginBottom: 8 }} />
      <Shimmer shimmerElements={rowElement} style={{ marginBottom: 8 }} />
      <Shimmer shimmerElements={rowElement} style={{ marginBottom: 8 }} />
      <Shimmer shimmerElements={rowElement} style={{ marginBottom: 8 }} />
      <Shimmer shimmerElements={rowElement} style={{ marginBottom: 8 }} />
      <Shimmer shimmerElements={buttonElement} style={{ marginBottom: 5, marginTop: 15 }} />
    </div >
  );
}
